import React from 'react';

const Doctors = () => {
  return (
    <div className="doctors-page">
      <div className="page-header">
        <div className="container">
          <h1>Our Doctors</h1>
          <p>Meet our expert medical professionals</p>
        </div>
      </div>
      <div className="container section">
        <p>Doctors listing page - To be implemented with API integration</p>
      </div>
    </div>
  );
};

export default Doctors;
